angular.module('impactx.controlstructure').directive('appControlRelationView', [function () {
    return {
        scope: {
            id: '=',
            trns: '=',
            controlStructure: '=',
        },
        restrict: 'E',
        templateUrl: 'shared/relation-view/templates/relation.html',
        transclude: true
    };
}]);